document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('SizeChartOverlay');
  const modal   = document.getElementById('SizeChartModal');

  if (!overlay || !modal) return;

  // Move modal and overlay to body to escape any CSS transform on parent
  document.body.appendChild(overlay);
  document.body.appendChild(modal);

  function openSizeChart() {
    overlay.classList.add('is-open');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.size-chart-modal__close').focus();
  }

  function closeSizeChart() {
    overlay.classList.remove('is-open');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.size-chart-btn').forEach(function (btn) {
    btn.addEventListener('click', openSizeChart);
  });

  overlay.addEventListener('click', closeSizeChart);
  modal.querySelector('.size-chart-modal__close').addEventListener('click', closeSizeChart);

  modal.querySelectorAll('.size-chart-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      const target = this.dataset.tab;
      modal.querySelectorAll('.size-chart-tab').forEach(t => t.classList.remove('is-active'));
      modal.querySelectorAll('.size-chart-panel').forEach(p => p.classList.remove('is-active'));
      this.classList.add('is-active');
      modal.querySelector('[data-panel="' + target + '"]').classList.add('is-active');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSizeChart();
  });
});
